import React from 'react';
import { PapiPcp } from '@wix/da-papi-types';
import AttachedFile from '@wix/da-ds/pkg/AttachedFile';

import s from './AttachmentsList.scss';

const LIST_MAX_VISIBLE_ITEMS = 100;

interface Props {
  assets: PapiPcp['assets'];
}

const AttachmentsList: React.FC<Props> = ({ assets = [] }) => {
  if (assets.length < 1) {
    return null;
  }

  const visibleAssets = assets.slice(0, LIST_MAX_VISIBLE_ITEMS);
  return (
    <div className={s['root']}>
      {visibleAssets.map((asset, idx) => (
        <AttachedFile
          className={s['attachment']}
          key={`asset-${idx}`}
          name={asset.filename!}
          size={asset.filesize!}
          type={asset.type!}
          width={asset.width}
          height={asset.height}
        />
      ))}
    </div>
  );
};
AttachmentsList.displayName = 'AttachmentsList';

export default AttachmentsList;
